const publicPath = /^(?:\/$|\/(?:pages|products|collections|blogs|policies)(?:\/|$)|\/search(?:\/|$)|\/cart$)/;
const languageRoots = {ms:'/ms', 'zh-CN':'/zh'};

export function localizedHref(href, locale, origin, languageRoot = languageRoots[locale]) {
  if (!['ms', 'zh-CN'].includes(locale) || typeof href !== 'string' || !href || /^(?:#|mailto:|tel:|javascript:|data:)/i.test(href)) return href;
  let url;
  try { url = new URL(href, origin); } catch { return href; }
  if (url.origin !== origin || !publicPath.test(url.pathname)) return href;
  const root = /^\/[a-z0-9-]+(?:\/[a-z0-9-]+)*\/?$/i.test(languageRoot) ? languageRoot.replace(/\/$/, '') : languageRoots[locale];
  return root + (url.pathname === '/' ? '' : url.pathname) + url.search + url.hash;
}

export function localizationReturnTo(location) {
  const params = new URLSearchParams();
  const allowed = /^(?:view|variant|category|q|page|sort_by|preview_theme_id|filter\.[\w.]+)$/;
  for (const [key,value] of new URLSearchParams(location.search)) if (allowed.test(key)) params.append(key,value);
  const query = params.toString();
  const hash = /^#[a-z][\w-]{0,100}$/i.test(location.hash) ? location.hash : '';
  return location.pathname + (query ? '?' + query : '') + hash;
}

export function initializeLocalization(document, location) {
  const language = document.documentElement.lang.toLowerCase();
  const locale = language === 'zh-cn' ? 'zh-CN' : language;
  const languageRoot = document.documentElement.getAttribute('data-ouson-language-root') || languageRoots[locale];
  const selectors = [...document.querySelectorAll('.ouson-language-switch')];
  for (const selector of selectors) {
    selector.addEventListener('toggle', () => {
      if (selector.open) selectors.forEach(other => { if (other !== selector) other.open = false; });
    });
    selector.addEventListener('keydown', event => {
      if (event.key === 'Escape' && selector.open) {
        selector.open = false;
        selector.querySelector('summary').focus();
      }
    });
    selector.querySelector('form')?.addEventListener('submit', event => {
      const form = event.currentTarget;
      let input = form.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.append(input);
      }
      input.value = localizationReturnTo(location);
    });
  }
  document.addEventListener('click', event => {
    for (const selector of selectors) if (selector.open && !selector.contains(event.target)) selector.open = false;
  });
  if (!['ms', 'zh-CN'].includes(locale)) return;
  const localize = root => {
    const links = root.matches?.('a[href]') ? [root] : [];
    links.push(...root.querySelectorAll('a[href]'));
    for (const link of links) {
      if (link.hasAttribute('hreflang') || link.hasAttribute('download') || link.closest('.ouson-localization-form')) continue;
      const before = link.getAttribute('href');
      const after = localizedHref(before, locale, location.origin, languageRoot);
      if (after !== before) link.setAttribute('href', after);
    }
    for (const option of root.querySelectorAll('[data-page-select] option')) {
      const before = option.getAttribute('value');
      const after = localizedHref(before, locale, location.origin, languageRoot);
      if (after !== before) option.setAttribute('value', after);
    }
  };
  localize(document);
  const Observer = document.defaultView.MutationObserver;
  const observer = new Observer(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) localize(node);
  });
  observer.observe(document.body, {childList:true,subtree:true});
}

if (typeof document !== 'undefined') initializeLocalization(document, window.location);
